import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import EmptyState from "@/components/base/EmptyState";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="mx-auto w-full max-w-[1360px] px-4 py-16 md:px-8 md:py-24">
        <div className="mb-8 text-center">
          <div className="font-display text-7xl font-semibold tracking-tight text-background-300 md:text-9xl">
            404
          </div>
          <p className="mt-2 font-mono text-xs text-foreground-500">{location.pathname}</p>
        </div>
        <EmptyState
          icon="ri-compass-3-line"
          title="这个页面还没有内容"
          desc="你访问的地址不存在，或者对应页面正在整理中。可以回到首页，或从影片分类重新进入。"
        />
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/category"
            className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-accent-500 hover:text-accent-400"
          >
            浏览全部影片
          </Link>
          <Link
            to="/search"
            className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-accent-500 hover:text-accent-400"
          >
            搜索影片
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}